import React from 'react'
import './App.css'
import './FeesPage.css' // the Feepage stylesheet (same import as the other pages)
import './Home.css' // shared home additions + category styles
import { Link } from 'react-router-dom'
import Axios from 'axios'
import { BsArrowRight } from 'react-icons/bs'
import { IoIosArrowBack } from 'react-icons/io'
import Header from './layouts/Header'
import Header2 from './components/Header2'
import { API_URL } from './config'

const pad = (n) => String(n).padStart(2, '0')

class Categories extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      eventcategory: [],
      loading: true,
      error: '',
    }
  }

  componentDidMount() {
    document.title = 'Categories - Karamale'

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=EVENTCATEGORY&limit=`)
      .then((response) => {
        this.setState({
          eventcategory: Array.isArray(response.data) ? response.data : [],
          loading: false,
        })
      })
      .catch(() => {
        this.setState({
          loading: false,
          error: 'We couldn’t load the categories.',
        })
      })
  }

  render() {
    const { eventcategory, loading, error } = this.state
    const loggedIn = localStorage.getItem('customername') !== null

    return (
      <div className="fp-page">
        {loggedIn ? <Header2 /> : <Header />}

        <main>
          {/* ---------- Heading ---------- */}
          <section className="fp-hero fp-hero--slim">
            <div className="fp-aurora" aria-hidden="true">
              <span className="fp-aurora__a" />
              <span className="fp-aurora__b" />
            </div>

            <div className="fp-wrap">
              <button type="button" className="fp-back" onClick={() => this.props.history.goBack()}>
                <IoIosArrowBack aria-hidden="true" />
                <span>Back</span>
              </button>

              <h1>
                Explore by <em>category.</em>
              </h1>

              <p className="fp-hero__sub">Find events that match what you're looking for.</p>

              {!loading && !error && (
                <span className="fp-count">
                  {eventcategory.length} {eventcategory.length === 1 ? 'category' : 'categories'}
                </span>
              )}
            </div>
          </section>

          {/* ---------- Categories ---------- */}
          <section className="fp-section fp-section--last">
            <div className="fp-wrap">
              {loading && (
                <div className="fp-catgrid" aria-busy="true" aria-label="Loading categories">
                  {Array.from({ length: 9 }).map((_, index) => (
                    <div className="fp-catskel" key={index} />
                  ))}
                </div>
              )}

              {!loading && error && (
                <div className="fp-state" role="alert">
                  <h3>We couldn't load categories</h3>
                  <p>Check your connection and try again.</p>
                  <div className="fp-actions fp-actions--center">
                    <button
                      type="button"
                      className="fp-btn fp-btn--brand"
                      onClick={() => window.location.reload()}
                    >
                      Try again
                    </button>
                  </div>
                </div>
              )}

              {!loading && !error && eventcategory.length > 0 && (
                <div className="fp-catgrid">
                  {eventcategory.map((item, index) => (
                    <Link
                      key={`${item.category}-${index}`}
                      to={{
                        pathname: '/category',
                        state: {
                          fromHome: true,
                          provinceid: item.provinceid,
                          category: item.category,
                          province: item.province,
                        },
                      }}
                      className="fp-cat"
                    >
                      <span className="fp-cat__initial" aria-hidden="true">
                        {String(item.category || '')
                          .charAt(0)
                          .toUpperCase()}
                      </span>

                      <span className="fp-cat__n">{pad(index + 1)}</span>

                      <span className="fp-cat__name">{item.category}</span>

                      <span className="fp-cat__arrow">
                        <BsArrowRight aria-hidden="true" />
                      </span>
                    </Link>
                  ))}
                </div>
              )}

              {!loading && !error && eventcategory.length === 0 && (
                <div className="fp-state">
                  <h3>No categories found</h3>
                  <p>There are currently no event categories available.</p>
                </div>
              )}
            </div>
          </section>
        </main>
      </div>
    )
  }
}

export default Categories
